import { BusstopSearchComponent } from 'src/app/component/busstop-search/busstop-search.component';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';

import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { TripStop, User } from '@shared/models';
import { formatSqlDate, getMexicanDatetime } from '@shared/utils';

@Component({
  selector: 'app-tickets-search',
  templateUrl: './tickets-search.page.html',
  styleUrls: ['./tickets-search.page.scss'],
})
export class TicketsSearchPage implements OnInit {
  maxDate: string | null = null;
  direction = 'go';
  user: User | null = null;
  today: string | null = null;
  date: string | null = null;
  stop: TripStop | null = null;

  constructor(
    private authService: AuthService,
    private router: Router,
    private modalCtrl: ModalController,
    private dataService: DataService
  ) {}

  ngOnInit() {
    this.authService.getUser().then((user) => {
      this.user = user;
      const nowInMexico = getMexicanDatetime();
      const now = new Date(nowInMexico);
      this.today = formatSqlDate(nowInMexico);
      // CCM 30 dias
      // CEM 7 dias
      const daysLimitToBook = this.user?.campus_current === 3 ? 30 : 7;
      const maxDate = new Date().setDate(now.getDate() + daysLimitToBook);
      this.maxDate = formatSqlDate(maxDate);
      this.date = this.today;
    });
  }

  goSearch() {
    if (!this.date) {
      return;
    }
    const ticketSearch = {
      stop: this.stop,
      date: this.date + ' 23:01:00',
      type: this.direction,
    };
    this.dataService.setData('ticket-search', ticketSearch);
    this.router.navigate(['/tecservice-transportec/transportec/search']);
  }

  searchStops() {
    this.modalCtrl
      .create({
        component: BusstopSearchComponent,
        componentProps: {
          type: this.direction,
        },
      })
      .then((modal) => {
        modal.present();
        modal.onDidDismiss().then((res) => {
          if (res.data && res.data.stop) {
            this.stop = res.data.stop;
          }
        });
      });
  }

  changeDirection() {
    this.stop = null;
  }
}
